module.exports = __webpack_public_path__ + "img/hruba-stavba.f37b5fb7.svg";